import React, { useEffect, useMemo } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import usePlaylistDrag from './hooks/usePlaylistDrag';
import useContentCrud from '../ContentPage/useContentCrud';
import Layout from '@components/layout';
import PlaylistTitle from './PlaylistTitle';
import Playlist from './Playlist';
import Content from './Content';
import usePlaylistCrud from './hooks/usePlaylistCrud';
import useFilterContentByType from '../../hooks/useFilterContentByType';
import isEmpty from 'lodash/isEmpty';
import useDevicesFilter from '../DevicesPage/hooks/useDevicesFilter';
import map from 'lodash/map';
import uniqueId from 'lodash/uniqueId';

function PlaylistPage() {
  const params = useParams();
  const { content } = useContentCrud({});
  const {
    contents: playlistContents,
    calcPlaylistDuration,
    playlist = {},
    loading,
    onFetchPlaylist,
    onCopy,
    onDelete: onDeletePlaylist,
    onSave,
    onEditPlaylist,
  } = usePlaylistCrud({ params });

  const {
    content: filteredContent,
    tabList,
    onChange,
  } = useFilterContentByType({ content });

  const {
    state,
    duration,
    onDragEnd,
    onDragStart,
    onDelete,
    onChangeItemDuration,
  } = usePlaylistDrag(
    params.id,
    content,
    playlistContents,
    calcPlaylistDuration,
    onSave(params.id)
  );

  const { sort, onSort, sortDevices, onSearch, filter } = useDevicesFilter();

  const isLoading = useMemo(() => {
    return (
      loading ||
      (!loading && !playlistContents) ||
      (!loading && !isEmpty(playlistContents) && !state)
    );
  }, [loading, state, playlistContents]);

  useEffect(() => {
    if (params.id) {
      onFetchPlaylist(params.id);
    }
  }, [params]);

  return (
    <div className="playlist-page playlist">
      <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
        <div
          className={cn('playlist__list', {
            'playlist__list--empty': false,
          })}
        >
          <PlaylistTitle
            playlist={playlist}
            playlistDuration={duration}
            onChangeColor={onEditPlaylist}
            onRename={onEditPlaylist}
            onCopy={onCopy}
            onDelete={onDeletePlaylist}
          />
          <Playlist
            items={state}
            loading={isLoading}
            onDelete={onDelete}
            onChangeItemDuration={onChangeItemDuration}
          />
        </div>
        <Content
          content={sortDevices(filter(filteredContent))}
          tabList={tabList}
          onChange={onChange}
          sort={sort}
          onSort={onSort}
          onSearch={onSearch}
        />
      </DragDropContext>
    </div>
  );
}

export default PlaylistPage;
